/***
 * @file:è¡¨æ ¼å¬ç¨æ¹æ³æå¡ï¼ åå« è¡¨ååè¡¨æ ¼
 * @Date: 2019-08-23 10:23:20
 * @author: linkun.he
 */
import { Injectable } from '@angular/core';

import { COMMON_COMFIG } from '@ithinkdt/shared/utils';
import { cloneDeep, isEmpty } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class TableService {
  constructor() {}

  /**
   * åå»ºè¡¨ååºç¡æ°æ®
   * @param data è¡¨æ ¼åè¡æ°æ®
   * @param code æä½codeç 
   */
  createFormData(data, code) {
    return Object.create({
      data,
      code,
    });
  }

  /**
   * åæ°æ®
   * @param tableData è¢«åå¼çæ°ç»
   * @param idName éè¦åå¼çå±æ§å
   */
  getCheckedIds(tableData, idName?) {
    const ids = [];
    tableData.forEach((data) => {
      if (data.checked) {
        ids.push(idName ? data[idName] : data.id);
      }
    });
    return ids.join(',');
  }

  /**
   * @desc è·åå½åcheckBoxçç¶æ
   * ä¸ç§ç¶æï¼ å¨éãéæ©é¨åãå¨æªé
   */
  getCheckedStatus(tableData) {
    if (isEmpty(tableData)) {
      return {
        allChecked: false,
        indeterminate: false,
      };
    }
    const allChecked = tableData.filter((item) => !item.disabled).every((value) => value.checked === true); // å¨éä¸­
    const allUnChecked = tableData.filter((item) => !item.disabled).every((value) => !value.checked); // å¨æªéä¸­
    return {
      allChecked,
      indeterminate: !allChecked && !allUnChecked,
    };
  }

  /**
   * @desc è·åæåºåæ°
   * @param sort æåºçåæ°ï¼å®æ¯ä¸ä¸ªå¯¹è±¡
   *          key: è¦æåºçå­æ®µ
   *          value: æåºæ¹å¼
   * å `ng-zorro`ç»ä»¶è¿åçæåºæ¹å¼å­ç¬¦ä¸²æ¯`ascend`å`descend`ï¼
   * èæä»¬åç«¯çæåºæ¹å¼å­æ®µæ¯`asc`å`desc`ï¼æä»¥å¾åå¦ä¸è½¬æ¢ã
   */
  getSortData(sort) {
    const sortMeta = cloneDeep(COMMON_COMFIG.DEFAULT_SORT);
    if (!sort.value) {
      return sortMeta;
    }

    sortMeta.sortName = sort.key;
    sort.value === COMMON_COMFIG.SORT_META_NGZORRO.ascend
      ? (sortMeta.sortOrder = COMMON_COMFIG.SORT_META_ITHINKDT.ascend)
      : (sortMeta.sortOrder = COMMON_COMFIG.SORT_META_ITHINKDT.descend);

    return sortMeta;
  }
}
